import type { Customer, NewCustomer } from '@/models/Customer';
import CoreApi from '@/api/CoreApi';

export async function loadCustomers(): Promise<Customer[]> {
  const response = await CoreApi.axiosClient.get('/admin/customers');
  return response.data;
}

export async function createCustomer(
  newCustomer: NewCustomer,
): Promise<Customer> {
  const response = await CoreApi.axiosClient.post(
    '/admin/customers',
    newCustomer,
  );
  return response.data;
}

export async function patchCustomer(
  customerToPatch: Customer,
): Promise<Customer> {
  const response = await CoreApi.axiosClient.patch(
    '/admin/customers',
    customerToPatch,
  );
  return response.data;
}

export async function deleteCustomer(
  customerToDelete: Customer,
): Promise<void> {
  await CoreApi.axiosClient.delete(`/admin/customers/${customerToDelete.uuid}`);
}
